import { createAsyncThunk } from "@reduxjs/toolkit";
import { typedAdminAPI } from "../api/typedApi";
import { toast } from "react-toastify";
import i18n from "i18next";

export const changeVoucherStatus = createAsyncThunk(
  "admin/changeVoucherStatus",
  async (
    { id, isActive }: { id: number; isActive: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await typedAdminAPI.changeVoucherStatus(id, isActive);
      toast.success(i18n.t("vouchersPage.changeVoucherToast") as string, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return response.data;
    } catch (error: any) {
      if (error.response.data.status === 404) {
        toast.error(i18n.t("vouchersPage.voucherNotFound") as string, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return rejectWithValue(i18n.t("vouchersPage.voucherNotFound") as string);
      }
      return rejectWithValue(
        i18n.t("validation.somethingWentWrong") as string
      );
    }
  }
);
